import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=dc3d35f0&scoped=true&"
import script from "./reg.vue?vue&type=script&lang=js&"
export * from "./reg.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/login.less?vue&type=style&index=0&id=dc3d35f0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3d35f0",
  null
  
)

export default component.exports